import React from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-react';
import { LockInfo } from 'src/models/common/LockInfo';
import { isLockedByOther } from './editLockUtils';
import { DEFAULT_LOCK_MESSAGES, Action } from './constants';
import CONSTANTS from 'src/utils/constants';

export interface EditLockButtonBarProps {
    viewMode?: string;
    lockInfo?: LockInfo | null;
    lockInfoLoading: boolean;
    currentUser?: string;
    actionInProgress: Action | null;
    onEdit: () => void;
    onSave: () => void;
    onConfirm: () => void;
    onRevert: () => void;
}

export function EditLockButtonBar(props: EditLockButtonBarProps) {
    const { viewMode, lockInfo, lockInfoLoading, currentUser, actionInProgress, onEdit, onSave, onConfirm, onRevert } = props;
    const anyActionInProgress = actionInProgress !== null;
    const lockedByOther = isLockedByOther(lockInfo, currentUser);

    const showActionButtons = viewMode === CONSTANTS.VIEW_MODE.EDITABLE ||
        actionInProgress === Action.SAVE || actionInProgress === Action.CONFIRM || actionInProgress === Action.REVERT;

    if (showActionButtons) {
        return (
            <SpaceBetween direction="horizontal" size="s">
                <Button
                    variant="normal"
                    loading={actionInProgress === Action.SAVE}
                    disabled={anyActionInProgress && actionInProgress !== Action.SAVE}
                    onClick={onSave}
                >
                    Save
                </Button>
                <Button
                    variant="normal"
                    loading={actionInProgress === Action.REVERT}
                    disabled={anyActionInProgress && actionInProgress !== Action.REVERT}
                    onClick={onRevert}
                >
                    Revert
                </Button>
                <Button
                    variant="primary"
                    loading={actionInProgress === Action.CONFIRM}
                    disabled={anyActionInProgress && actionInProgress !== Action.CONFIRM}
                    onClick={onConfirm}
                >
                    Confirm
                </Button>
            </SpaceBetween>
        );
    }

    return (
        <Button
            variant="primary"
            loading={actionInProgress === Action.EDIT}
            disabled={lockInfoLoading || lockedByOther || (anyActionInProgress && actionInProgress !== Action.EDIT)}
            disabledReason={
                lockedByOther
                    ? DEFAULT_LOCK_MESSAGES.lockedByOther(lockInfo?.lockedBy || 'another user')
                    : (lockInfoLoading ? 'Loading...' : undefined)
            }
            onClick={onEdit}
        >
            Edit
        </Button>
    );
}

export default EditLockButtonBar;
